<!-- Divider -->
<div
    class="zuper-vertical-navigation-item-wrapper divider"
    [ngClass]="item.classes?.wrapper"></div>
